import { FEaaSComponent } from './FEaaSComponent';
import React from 'react';
export const FEAAS_WRAPPER_RENDERING_NAME = 'FEaaSWrapper';
export const FEaaSWrapper = (props) => {
    var _a, _b;
    const styles = `component feaas ${(_a = props.params) === null || _a === void 0 ? void 0 : _a.styles}`.trimEnd();
    const id = (_b = props.params) === null || _b === void 0 ? void 0 : _b.RenderingIdentifier;
    return (React.createElement("div", { className: styles, id: id ? id : undefined },
        React.createElement("div", { className: "component-content" },
            React.createElement(FEaaSComponent, Object.assign({}, props)))));
};
